import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exams-course-edit',
  templateUrl: './exams-course-edit.component.html',
  styleUrls: ['./exams-course-edit.component.css']
})
export class ExamsCourseEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
